<template>
  <v-list-item
    dense
  >
    <v-list-item-avatar>
      <v-icon
        class="grey lighten-1 accent--text"
      >
        archive
      </v-icon>
    </v-list-item-avatar>

    <v-list-item-content>
      <v-list-item-title>
        {{ label }}
      </v-list-item-title>
      <v-list-item-subtitle>
        {{ description }}
      </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action>
      <v-menu
        offset-y
        left
        @click.stop=""
      >
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            v-on="on"
            @click.stop=""
          >
            <v-icon>more_vert</v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item
            v-if="event.isArchived"
            @click="unarchive()"
          >
            <v-list-item-title>
              <v-icon left>
                archive
              </v-icon>
              Unarchive
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import { get } from 'lodash'
import { mapActions } from 'vuex'

export default {
  props: {
    event: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      model: this.event
    }
  },

  computed: {
    label() {
      return get(this.model, 'label', '')
    },
    description() {
      return get(this.model, 'description', '')
    }
  },
  methods: {
    ...mapActions([ 'updateEvent' ]),
    async unarchive() {
      const payload = {
        isArchived: false,
        id: this.event.id
      }

      await this.updateEvent(payload)
    }
  }
}
</script>
<style>
  .smaller-chip {
    height: 20px !important;
  }
</style>
